export default __webpack_public_path__ + "media/images/tenant/hero_3-d0714a7e5d77e26c3b22bd7a2c15d945.webp";